import { RootState } from '@reducers';

export const selectPolicyCommissionInvoiceDetailsPageReducer = (state: RootState) => state.userDashboardRouteReducer.policyCommissionInvoiceDetailsPageReducer;
